// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"80bca2f4","998":"f44d3359"}[chunkId] + ".chunk.js";
};